import { IFootballTeam } from '../components/organisms/football-team/football-team';
import { IDriver, ITeam } from '../components/templates/season-ranking-page/season-ranking-page';

import { IAdvBoxAttributes } from './adv';

export interface IPlayersPage {
  teams: IFootballTeam[];
  isEditor?: boolean;
  title: string;
  footerButtonLabel?: string;
  type: sportsDetailCardtypes;
}

export interface ICardsIntcmp {
  playerTeam?: string;
  playerCard?: string;
}

export interface IGalleryTab {
  tabName: string;
  tabItemColor: string;
  cards: IDriver[] | ITeam[];
  type: sportsDetailCardtypes;
  tabsIntcmp?: string;
  cardsIntcmp?: ICardsIntcmp;
  dataElement?: string;
}
export interface IGalleryTabsWrapper {
  tabs: IGalleryTab[];
  title: string;
  footerButtonLabel?: string;
  fakeAdvs?: boolean;
  advBoxAttributes?: IAdvBoxAttributes;
}

export enum sportsDetailCardtypes {
  PROBABILI_FORMAZIONI = 'probabili-formazioni',
  PAGELLE = 'pagelle',
  MARCATORI = 'classifica-marcatori',
  DRIVERS = 'drivers',
  TEAMS = 'teams',
}
